import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AddRuleHelperFunctions } from 'src/app/services/add-rule-helper-functions.service';
import { HelperFunctions } from 'src/app/services/helper-functions';
import { PartnerServicesService } from 'src/app/services/partner-service/partner-services.service';
import { ValidateService } from 'src/app/services/ui/validate.service';
import { UserManagerService } from 'src/app/services/user-manager/user-manager.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-add-item',
  templateUrl: './add-item.component.html',
  styleUrls: ['./add-item.component.scss']
})
export class AddItemComponent implements OnInit {

  conditionOption: string;
  @Input() thresholdArr: any[];
  @Input() amounts: any = {};
  @Input() ruleConfig: any;
  @Input() parentIndex: any;
  @Input() ruleIndex: any;
  @Input() partner: any;

  error = {
    name: {
      erc: '1',
      value: ''
    },
    amt: {
      erc: '1',
      value: ''
    },
    min_amt: {
      erc: '1',
      value: ''
    },
    max_amt: {
      erc: '1',
      value: ''
    },
    percentage: {
      erc: '1',
      value: ''
    },
  };
  permissions ={
    canEdit: false
  }
  constructor(
    public addRuleHelperFxn: AddRuleHelperFunctions,
    private partnerService: PartnerServicesService,
    private helperFunctions: HelperFunctions,
    private translate: TranslateService,
    private userService: UserManagerService,
    private validateService: ValidateService,
  ) {}

  ngOnInit() {
    this.permissions.canEdit = this.userService.hasPrevilleges('SPORTS_P_B_EDIT_PARTNERS_REVENUE');
  }

  saveRow(row) {
    const fields = ['name'];
    const amountFields = ['amt']
    if (!this.validateForm(row, fields) || !this.validateAmount(row, amountFields)) {
      // console.log('validation failed');
      return;
    }

    const params: any = {};
    Object.assign(params, row);
    params.status = params.status && (params.status == true || params.status.includes('enable')) ? 'enable' : 'disabled';
    params.edit = undefined;
    // console.log(params)
    params.partnerID = params.general ? null : this.partner;
    row.inProgress = true;
    if (row.hasOwnProperty('id')) {
        this.partnerService.editPartnerDeductions(params).then(res => {
          row.inProgress = false;
          if (res.hasOwnProperty('erc') && res.erc == '0') {
            this.helperFunctions.presentAlert('success', this.translate.instant('success'), null,
            this.translate.instant('operation_successfull', ''), null);
            this.ruleConfig = res.data ? res.data : this.ruleConfig;
            // console.log(res)
            this.ruleConfig.edit = false;
          } else {
            Swal.close();
            // tslint:disable-next-line: max-line-length
            this.helperFunctions.presentAlert('error', this.translate.instant('failed'), null, res.msg ? res.msg : this.translate.instant('something_went_wrong'), null);
          }
         }).catch(err => {
          Swal.close();

          this.helperFunctions.presentAlert('error', 'Ooooops...',null, this.translate.instant('server_error'), null);
        }).finally (() => {

        });

      } else {
        this.partnerService.createPartnerDeductions(params).then(res => {
          row.inProgress = false;
          if (res.hasOwnProperty('erc') && res.erc == '0') {
            this.helperFunctions.presentAlert('success', this.translate.instant('success'), null,
            this.translate.instant('operation_successfull', ''), null).then(res => {
              this.ruleConfig = res.data ? res.data : this.ruleConfig;
              this.ruleConfig.edit = false;
            });

          } else {
            Swal.close();
            // tslint:disable-next-line: max-line-length
            this.helperFunctions.presentAlert('error', this.translate.instant('failed'), null, res.msg ? res.msg : this.translate.instant('something_went_wrong'), null);
          }
         }).catch(err => {
          Swal.close();

          this.helperFunctions.presentAlert('error', 'Ooooops...', this.translate.instant('server_error'), null, null);
        }).finally (() => {


        });

    }
    
  }
  saveRange(row){
    const fields = ['min_amt', 'max_amt', 'percentage'];
    if (!this.validateAmount(row, fields)) {
      // console.log('validation failed');
      return;
    }
    // console.log(row)
    const params: any = {};
    Object.assign(params, row);
    params.edit = undefined;
    params.partnerID = this.partner;

    this.amounts.inProgress = true;
    if (row.hasOwnProperty('shareid')) {
      this.partnerService.editPartnershares(params).then(res => {
        row.inProgress = false;
        if (res.hasOwnProperty('erc') && res.erc == '0') {
          this.helperFunctions.presentAlert('success', this.translate.instant('success'), null,
          this.translate.instant('operation_successfull', ''), null);
          this.amounts = res.data && res.data.length > 0 ? res.data[0] : this.amounts;
          this.amounts.edit = false;
         
        } else {
          Swal.close();
          // tslint:disable-next-line: max-line-length
          this.helperFunctions.presentAlert('error', this.translate.instant('failed'), null, res.msg ? res.msg : this.translate.instant('something_went_wrong'), null);
        }
       }).catch(err => {
        Swal.close();

        this.helperFunctions.presentAlert('error', 'Ooooops...', null,this.translate.instant('server_error'), null);
      }).finally (() => {
        this.amounts.inProgress = false;
      });
    } else {
      this.partnerService.createPartnershares(params).then(res => {
        this.amounts.inProgress = false;
        if (res.hasOwnProperty('erc') && res.erc == '0') {
          this.helperFunctions.presentAlert('success', this.translate.instant('success'), null,
          this.translate.instant('operation_successfull', ''), null);
          this.amounts = res.data && res.data.length > 0 ? res.data[0] : this.amounts;
          this.amounts.edit = false;
        } else {
          Swal.close();
          // tslint:disable-next-line: max-line-length
          this.helperFunctions.presentAlert('error', this.translate.instant('failed'), null, res.msg ? res.msg : this.translate.instant('something_went_wrong'), null);
        }
       }).catch(err => {
        Swal.close();

        this.helperFunctions.presentAlert('error', 'Ooooops...', null, this.translate.instant('server_error'), null);
      }).finally (() => {
        this.amounts.inProgress = false;
      });


  }
  }
  validateForm(fields, testFields) {
    const result = this.validateService.validateRequiredFields(fields, testFields);
    for (const item of testFields) {
      this.error[item] = result.data[item];
    }
    return result.submit;
  }
  checkboxChange(ev, row, str) {
    row[str] = !row[str];
  }
  validateAmount(fields, testFields){
    const result = this.validateService.validateRequiredFields(fields, testFields);
    for (const item of testFields) {
      this.error[item] = result.data[item];
    }
    return result.submit;
  }
}
